import { LineSheetSetType } from "@/features/line-sheet-sets/line-sheet-set.types";
import AppSelect from "@/features/line-sheet-sets/app-select";
import { useTranslation } from "react-i18next";
import { toTitle } from "@/utils/case";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface BaseAppLineSheetTypeSelectorProps {
  isClearable?: boolean;
  width?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  showCount?: boolean;
  showSelectedBorder?: boolean;
  showEmptyDataOption?: boolean;
  isOrderHistory?: boolean;
  minWidth?: string;
}

interface SingleAppLineSheetTypeSelectorProps
  extends BaseAppLineSheetTypeSelectorProps {
  value?: LineSheetSetType;
  onSelect?: (type?: LineSheetSetType) => void;
  isMultiple?: false;
}

interface MultipleAppLineSheetTypeSelectorProps
  extends BaseAppLineSheetTypeSelectorProps {
  value?: LineSheetSetType[];
  onSelect?: (type?: LineSheetSetType[]) => void;
  isMultiple: true;
}

type AppLineSheetTypeSelectorProps =
  | SingleAppLineSheetTypeSelectorProps
  | MultipleAppLineSheetTypeSelectorProps;

export default function AppLineSheetTypeSelector(
  props: AppLineSheetTypeSelectorProps
) {
  const {
    value,
    onSelect,
    width = "144px",
    isClearable,
    isDisabled,
    isReadOnly,
    showCount,
    showSelectedBorder,
    showEmptyDataOption,
    isMultiple,
    isOrderHistory,
    minWidth,
  } = props;
  const { t } = useI18nHelper();

  const options = [
    {
      name: t("line_sheet_set.types.season").toUpperCase(),
      value: "SEASON" as LineSheetSetType,
    },
    {
      name: t("line_sheet_set.types.stock").toUpperCase(),
      value: "STOCK" as LineSheetSetType,
    },
    // 단품오더는 더 이상 사용하지 않아 선택지에서 제외
    // { name: t("api_order"), value: "API_ORDER" as LineSheetSetType },
  ];

  if (isMultiple) {
    return (
      <AppSelect<LineSheetSetType>
        width={width}
        name={toTitle(t("line_sheet_set.type"))}
        options={options.filter((item) =>
          isOrderHistory ? item.value !== "API_ORDER" : true
        )}
        value={value as LineSheetSetType[]}
        onSelect={onSelect as (value?: LineSheetSetType[]) => void}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        showCount={showCount}
        showSelectedBorder={showSelectedBorder}
        showEmptyDataOption={showEmptyDataOption}
        isMultiple={true}
        minWidth={minWidth}
      />
    );
  }
  return (
    <AppSelect<LineSheetSetType>
      width={width}
      name={toTitle(t("line_sheet_set.type"))}
      options={options}
      value={value as LineSheetSetType}
      onSelect={onSelect as (value?: LineSheetSetType) => void}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      showCount={showCount}
      showSelectedBorder={showSelectedBorder}
      showEmptyDataOption={showEmptyDataOption}
      isMultiple={false}
    />
  );
}
